import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as actions from './actions'
import * as api from './api'
import { getSortedIds } from 'helpers/jsonAPI'
import { message } from 'antd'

function* fetchArcAdvertisersWorker({ payload }) {
  try {
    const { data } = yield call(api.getArcAdvertisers, payload)
    if (data) {
      yield put(
        actions.fetchArcAdvertisersSuccess({
          ...payload,
          advertisers: data.data,
          sortedIds: getSortedIds(data.data),
          pageCount: data.meta?.pagination?.pages || 1,
        })
      )
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchArcAdvertisersFailure())
  }
}

function* fetchArcAdvertiserDetailsWorker({ payload }) {
  try {
    const { data } = yield call(api.getArcAdvertiser, payload.id)

    if (data) {
      yield put(
        actions.fetchArcAdvertiserDetailsSuccess({
          advertiser: data.data,
        })
      )
    }
  } catch (error) {
    console.error(error)
    yield put(actions.fetchArcAdvertiserDetailsFailure())
  }
}

function* createArcAdvertiserWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    yield call(api.createArcAdvertiser, payload.data)
    message.success('Arc advertiser created successfully')
    if (payload.callback) {
      payload.callback()
    }
  } catch (error) {
    console.error(error)
    message.error('Failed to create arc advertiser')
  } finally {
    yield put(actions.finishSaving())
  }
}

function* updateArcAdvertiserWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    yield call(api.updateArcAdvertiser, payload.data)
    message.success('Arc advertiser updated successfully')
    if (payload.callback) {
      payload.callback()
    }
  } catch (error) {
    console.error(error)
    message.error('Failed to update arc advertiser')
  } finally {
    yield put(actions.finishSaving())
  }
}

function* deleteArcAdvertiserWorker({ payload }) {
  try {
    yield put(actions.startSaving())
    yield call(api.deleteArcAdvertiser, payload.id)
    message.success('Arc advertiser deleted successfully')
    if (payload.callback) {
      payload.callback()
    }
  } catch (error) {
    console.error(error)
    message.error('Failed to delete arc advertiser')
  } finally {
    yield put(actions.finishSaving())
  }
}

export default function* () {
  yield all([
    takeLatest(actions.fetchArcAdvertisers, fetchArcAdvertisersWorker),
    takeLatest(actions.fetchArcAdvertiserDetails, fetchArcAdvertiserDetailsWorker),
    takeLatest(actions.createArcAdvertiser, createArcAdvertiserWorker),
    takeLatest(actions.updateArcAdvertiser, updateArcAdvertiserWorker),
    takeLatest(actions.deleteArcAdvertiser, deleteArcAdvertiserWorker),
  ])
}